import { apiClient } from "../config";

async function getAllUsersByOrganizationId(id:string) {
  const res = await apiClient.get(`admin/programs/admins-dropdown?organization_id=${id}`);
  return res.data;
}

export default getAllUsersByOrganizationId;
